import { useState } from "react";
import { X, Plus } from "lucide-react";

const DAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];

const DayRow = ({ index, slots, onChange }) => {
  const [time, setTime] = useState("");
  const add = () => {
    if (!time || slots.includes(time)) return;
    onChange([...slots, time].sort());
    setTime("");
  };
  return (
    <div className="rounded-2xl border border-border bg-white p-4" data-testid={`day-row-${index}`}>
      <div className="flex items-center justify-between gap-3 mb-3">
        <span className="font-serif text-lg text-ink">{DAYS[index]}</span>
        <span className="text-[11px] font-mono uppercase tracking-widest text-sage">{slots.length ? `${slots.length} orari` : "Chiuso"}</span>
      </div>
      <div className="flex flex-wrap gap-2 mb-3">
        {slots.map((s) => (
          <span key={s} className="inline-flex items-center gap-1 rounded-full bg-pine text-linen px-3 py-1 font-mono text-sm">
            {s}
            <button type="button" aria-label={`Rimuovi ${s}`} data-testid={`remove-slot-${index}-${s.replace(":", "")}`} onClick={() => onChange(slots.filter((x) => x !== s))} className="hover:text-clay"><X size={13} /></button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input type="time" step="900" value={time} onChange={(e) => setTime(e.target.value)} data-testid={`add-slot-input-${index}`} className="rounded-xl border border-border px-3 py-2 text-sm font-mono text-ink outline-none focus:border-pine" />
        <button type="button" onClick={add} data-testid={`add-slot-btn-${index}`} className="inline-flex items-center gap-1 rounded-full border border-pine text-pine px-4 py-2 text-sm font-medium hover:bg-pine hover:text-linen transition-colors"><Plus size={14} /> Aggiungi</button>
      </div>
    </div>
  );
};

export const WeeklyEditor = ({ weekly, onChange }) => (
  <div className="grid gap-3 md:grid-cols-2" data-testid="weekly-editor">
    {DAYS.map((_, i) => (
      <DayRow key={i} index={i} slots={weekly[String(i)] || []} onChange={(slots) => onChange({ ...weekly, [String(i)]: slots })} />
    ))}
  </div>
);
